import request from "@/utils/request"

// 上传图片-base64
export function indexBs64(data) {
  return request({
    url: "/api/index/bs64",
    method: "post",
    data,
  })
}

// 获取配置项
export function getSite(data) {
	return request({
		url: "/api/index/peizhi",
		method: "POST",
		data,
	})
}

// 登录
export function userLogin(data) {
  return request({
    url: "/api/user/login",
    method: "post",
    data,
  })
}

// 修改密码
export function userResetpwd(data) {
  return request({
    url: "/api/user/resetpwd",
    method: "post",
    data,
  })
}

// 用户详情
export function userUserInfo(data) {
  return request({
    url: "/api/user/user_info",
    method: "post",
    data,
  })
}

// 仓库列表
export function storehouseList(params) {
  return request({
    url: "/api/user/storehouse_list",
    method: "GET",
    params,
  })
}

// 仓库添加
export function storehouseAdd(data) {
  return request({
    url: "/api/user/storehouse_add",
    method: "POST",
    data,
  })
}

// 仓库修改
export function storehouseSave(data) {
  return request({
    url: "/api/user/storehouse_save",
    method: "POST",
    data,
  })
}

// 仓库删除
export function storehouseDel(data) {
  return request({
    url: "/api/user/storehouse_del",
    method: "POST",
    data,
  })
}

// 库存列表
export function stockList(data) {
  return request({
    url: "/api/user/stock_list",
    method: "POST",
    data,
    headers: {
      repeatSubmit: true
    }
  })
}

// 库存添加
export function stockAdd(data) {
  return request({
    url: "/api/user/stock_add",
    method: "POST",
    data,
  })
}

// 库存修改
export function stockSave(data) {
  return request({
    url: "/api/user/stock_save",
    method: "POST",
    data,
  })
}

// 库存删除
export function stockDel(data) {
  return request({
    url: "/api/user/stock_del",
    method: "POST",
    data,
  })
}

// 库存备注添加
export function stockRemarkAdd(data) {
  return request({
    url: "/api/user/stock_remark_add",
    method: "POST",
    data,
  })
}

// 库存备注删除
export function stockRemarkDel(data) {
  return request({
    url: "/api/user/stock_remark_del",
    method: "POST",
    data,
  })
}

// 库存备注列表
export function stockRemarkList(data) {
  return request({
    url: "/api/user/stock_remark_list",
    method: "POST",
    data,
  })
}

// 货品方列表
export function supplierList(data) {
  return request({
    url: "/api/user/supplier_list",
    method: "POST",
    data,
  })
}

// 货品方添加
export function supplierAdd(data) {
  return request({
    url: "/api/user/supplier_add",
    method: "POST",
    data,
  })
}

// 货品方修改
export function supplierSave(data) {
  return request({
    url: "/api/user/supplier_save",
    method: "POST",
    data,
  })
}

// 货品方删除
export function supplierDel(data) {
  return request({
    url: "/api/user/supplier_del",
    method: "POST",
    data,
  })
}

// 货品方爱签公司列表
export function supplier_list(data) {
  return request({
    url: "/api/supplier/list",
    method: "POST",
    data,
  })
}

// 货品方爱签公司添加
export function supplier_add(data) {
  return request({
    url: "/api/supplier/add",
    method: "POST",
    data,
  })
}

// 货品方爱签公司修改
export function supplier_save(data) {
  return request({
    url: "/api/supplier/save",
    method: "POST",
    data,
  })
}

// 货品方爱签公司删除
export function supplier_del(data) {
  return request({
    url: "/api/supplier/del",
    method: "POST",
    data,
  })
}

// 商品分类列表
export function goodsClassList(params) {
  return request({
    url: "/api/user/goods_class_list",
    method: "GET",
    params,
  })
}

// 商品分类添加
export function goodsClassAdd(params) {
  return request({
    url: "/api/user/goods_class_add",
    method: "POST",
    params,
  })
}

// 商品分类修改
export function goodsClassSave(params) {
  return request({
    url: "/api/user/goods_class_save",
    method: "POST",
    params,
  })
}

// 商品分类删除
export function goodsClassDel(params) {
  return request({
    url: "/api/user/goods_class_del",
    method: "POST",
    params,
  })
}

// 商品列表
export function goodsList(data) {
  return request({
    url: "/api/user/goods_list",
    method: "POST",
    data,
  })
}

// 商品详情
export function goodsInfo(data) {
  return request({
    url: "/api/index/goods_info",
    method: "POST",
    data,
  })
}

// 商品添加
export function goodsAdd(data) {
  return request({
    url: "/api/user/goods_add",
    method: "POST",
    data,
  })
}

// 商品修改
export function goodsSave(data) {
  return request({
    url: "/api/user/goods_save",
    method: "POST",
    data,
  })
}

// 商品删除
export function goodsDel(data) {
  return request({
    url: "/api/user/goods_del",
    method: "POST",
    data,
  })
}

// 库存统计
export function inventoryStatistics(data) {
  return request({
    url: "/api/user/inventory_statistics",
    method: "POST",
    data,
  })
}

// 库存统计-只传仓库
export function inventory_statistics_new(data) {
  return request({
    url: "/api/user/inventory_statistics_new",
    method: "POST",
    data,
  })
}

// 业绩统计
export function customerServiceStatistics(data) {
  return request({
    url: "/api/user/customer_service_statistics",
    method: "POST",
    data,
  })
}

// 平台列表
export function platformList(data) {
  return request({
    url: "/api/user/platform_list",
    method: "POST",
    data,
  })
}

// 平台添加
export function platformAdd(data) {
  return request({
    url: "/api/user/platform_add",
    method: "POST",
    data,
  })
}

// 平台修改
export function platformSave(data) {
  return request({
    url: "/api/user/platform_save",
    method: "POST",
    data,
  })
}

// 平台修改
export function platformDel(data) {
  return request({
    url: "/api/user/platform_del",
    method: "POST",
    data,
  })
}

// 订单列表
export function orderList(data) {
  return request({
    url: "/api/user/order_list",
    method: "POST",
    data,
  })
}

// 订单新增
export function orderAdd(data) {
  return request({
    url: "/api/user/order_add",
    method: "POST",
    data,
  })
}

// 订单修改
export function orderSave(data) {
  return request({
    url: "/api/user/order_save",
    method: "POST",
    data,
  })
}

// 订单删除
export function orderDel(data) {
  return request({
    url: "/api/user/order_del",
    method: "POST",
    data,
  })
}

// 计算订单发货时间
export function orderDelivertm(data) {
  return request({
    url: "/api/user/order_delivertm",
    method: "POST",
    data,
  })
}

// 计算订单发货时间
export function orderDelivertmInfo(data) {
  return request({
    url: "/api/user/order_delivertm_info",
    method: "POST",
    data,
  })
}

// 订单续租
export function orderRenewLease(data) {
  return request({
    url: "/api/user/order_renew_lease",
    method: "POST",
    data,
  })
}

// 订单发货
export function orderShipping(data) {
  return request({
    url: "/api/user/order_shipping",
    method: "POST",
    data,
  })
}

// 订单归还确认
export function orderReturn(data) {
  return request({
    url: "/api/user/order_return",
    method: "POST",
    data,
  })
}

// 订单收货
export function orderReceipt(data) {
  return request({
    url: "/api/user/order_receipt",
    method: "POST",
    data,
  })
}

// 订单结算账单
export function orderSettlementCalculate(data) {
  return request({
    url: "/api/user/order_settlement_calculate",
    method: "POST",
    data,
  })
}

// 订单结算账单_V2
export function orderSettlementCalculate_V2(data) {
  return request({
    url: "/api/settlement/order_settlement_calculate_V2",
    method: "POST",
    data,
  })
}

// 订单结算
export function orderSettlement(data) {
  return request({
    url: "/api/user/order_settlement",
    method: "POST",
    data,
  })
}

// 订单结算_V2
export function orderSettlement_V2(data) {
  return request({
    url: "/api/settlement/order_settlement_V2",
    method: "POST",
    data,
  })
}

// 订单结算列表_V2
export function orderSettlementList_V2(data) {
  return request({
    url: "/api/settlement/order_settlement_list_V2",
    method: "POST",
    data,
  })
}

// 长租结算
export function long_order_settlement_calculate_V2(data) {
  return request({
    url: "/api/settlement/long_order_settlement_calculate_V2",
    method: "POST",
    data,
  })
}

// 订单发货撤回
export function orderWithdraw(data) {
  return request({
    url: "/api/user/order_withdraw",
    method: "POST",
    data,
  })
}

// 订单扣款
export function chargePay(data) {
  return request({
    url: "/api/charge/pay",
    method: "POST",
    data,
  })
}

// 订单解押
export function chargeClosure(data) {
  return request({
    url: "/api/charge/closure",
    method: "POST",
    data,
  })
}

// 订单解押-更改状态
export function orderAuth(data) {
  return request({
    url: "/api/user/order_auth",
    method: "POST",
    data,
  })
}

// 订单备注添加
export function orderRemarkAdd(data) {
  return request({
    url: "/api/user/order_remark_add",
    method: "POST",
    data,
  })
}

// 订单备注列表
export function orderRemarkList(data) {
  return request({
    url: "/api/user/order_remark_list",
    method: "POST",
    data,
  })
}

// 快递列表
export function expressList(data) {
  return request({
    url: "/api/user/express_list",
    method: "POST",
    data,
  })
}

// 快递添加
export function expressAdd(data) {
  return request({
    url: "/api/user/express_add",
    method: "POST",
    data,
  })
}

// 快递修改
export function expressSave(data) {
  return request({
    url: "/api/user/express_save",
    method: "POST",
    data,
  })
}

// 快递删除
export function expressDel(data) {
  return request({
    url: "/api/user/express_del",
    method: "POST",
    data,
  })
}

// 押金方式列表
export function depositList(data) {
  return request({
    url: "/api/user/deposit_list",
    method: "POST",
    data,
  })
}

// 押金方式添加
export function depositAdd(data) {
  return request({
    url: "/api/user/deposit_add",
    method: "POST",
    data,
  })
}

// 押金方式修改
export function depositSave(data) {
  return request({
    url: "/api/user/deposit_save",
    method: "POST",
    data,
  })
}

// 押金方式删除
export function depositDel(data) {
  return request({
    url: "/api/user/deposit_del",
    method: "POST",
    data,
  })
}

// 权限列表
export function userUserRule(data) {
  return request({
    url: "/api/user/user_rule",
    method: "POST",
    data,
  })
}

// 发货配置列表
export function provinceList(data) {
  return request({
    url: "/api/user/province_list",
    method: "POST",
    data,
  })
}

// 发货添加
export function provinceAdd(data) {
  return request({
    url: "/api/user/province_add",
    method: "POST",
    data,
  })
}

// 发货修改
export function provinceSave(data) {
  return request({
    url: "/api/user/province_save",
    method: "POST",
    data,
  })
}

// 发货删除
export function provinceDel(data) {
  return request({
    url: "/api/user/province_del",
    method: "POST",
    data,
  })
}

// 修改商家配置
export function updateMerchant(data) {
  return request({
    url: "/api/user/update_merchant",
    method: "POST",
    data,
  })
}

// 用户分组列表
export function userGroupIndex(data) {
  return request({
    url: "/api/user/user_group_index",
    method: "POST",
    data,
  })
}

// 用户分组添加
export function userGroupAdd(data) {
  return request({
    url: "/api/user/user_group_add",
    method: "POST",
    data,
  })
}

// 用户分组编辑
export function userGroupSave(data) {
  return request({
    url: "/api/user/user_group_save",
    method: "POST",
    data,
  })
}

// 用户分组删除
export function userGroupDel(data) {
  return request({
    url: "/api/user/user_group_del",
    method: "POST",
    data,
  })
}

// 付款方式列表
export function payModuleList(data) {
  return request({
    url: "/api/user/pay_module_list",
    method: "POST",
    data,
  })
}

// 付款方式添加
export function payModuleAdd(data) {
  return request({
    url: "/api/user/pay_module_add",
    method: "POST",
    data,
  })
}

// 付款方式编辑
export function payModuleSave(data) {
  return request({
    url: "/api/user/pay_module_save",
    method: "POST",
    data,
  })
}

// 付款方式删除
export function payModuleDel(data) {
  return request({
    url: "/api/user/pay_module_del",
    method: "POST",
    data,
  })
}

// 员工列表
export function userList(data) {
  return request({
    url: "/api/user/user_list",
    method: "POST",
    data,
  })
}

// 员工添加
export function userAdd(data) {
  return request({
    url: "/api/user/user_add",
    method: "POST",
    data,
  })
}

// 员工编辑
export function userSave(data) {
  return request({
    url: "/api/user/user_save",
    method: "POST",
    data,
  })
}

// 员工禁用/启用
export function userDel(data) {
  return request({
    url: "/api/user/user_del",
    method: "POST",
    data,
  })
}

// 分润记录
export function userMoneyLogList(data) {
  return request({
    url: "/api/user/user_money_log_list",
    method: "POST",
    data,
  })
}

// 利润变动
export function userMoneyLogUpdate(data) {
  return request({
    url: "/api/user/user_money_log_update",
    method: "POST",
    data,
  })
}

// 配件列表
export function accessoriesList(data) {
  return request({
    url: "/api/user/accessories_list",
    method: "POST",
    data,
  })
}

// 添加配件数量
export function accessoriesAddNum(data) {
  return request({
    url: "/api/user/accessories_add_num",
    method: "POST",
    data,
  })
}

// 添加配件数量备注
export function accessoriesRemark(data) {
  return request({
    url: "/api/user/accessories_remark",
    method: "POST",
    data,
  })
}

// 套餐列表
export function comboList(data) {
  return request({
    url: "/api/user/combo_list",
    method: "POST",
    data,
  })
}

// 套餐添加
export function comboAdd(data) {
  return request({
    url: "/api/user/combo_add",
    method: "POST",
    data,
  })
}

// 套餐修改
export function comboSave(data) {
  return request({
    url: "/api/user/combo_save",
    method: "POST",
    data,
  })
}

// 套餐删除
export function comboDel(data) {
  return request({
    url: "/api/user/combo_del",
    method: "POST",
    data,
  })
}

// 配件模版列表
export function accessoriesModeList(data) {
  return request({
    url: "/api/user/accessories_mode_list",
    method: "POST",
    data,
  })
}

// 配件模版添加
export function accessoriesModeAdd(data) {
  return request({
    url: "/api/user/accessories_mode_add",
    method: "POST",
    data,
  })
}

// 配件模版修改
export function accessoriesModeSave(data) {
  return request({
    url: "/api/user/accessories_mode_save",
    method: "POST",
    data,
  })
}

// 配件模版删除
export function accessoriesModeDel(data) {
  return request({
    url: "/api/user/accessories_mode_del",
    method: "POST",
    data,
  })
}

// 云市场地址解析
export function chargeAnalysis(data) {
  return request({
    url: "/api/charge/analysis",
    method: "POST",
    data,
  })
}

// 快递查询
export function chargeExpressQuery(data) {
  return request({
    url: "/api/charge/express_query",
    method: "POST",
    data,
  })
}

// 插件列表
export function chargePluginList(data) {
  return request({
    url: "/api/charge/plugin_list",
    method: "POST",
    data,
  })
}

// 修改闲鱼参数
export function xianyuPluginSaveXianyu(data) {
  return request({
    url: "/api/xianyuPlugin/save_xianyu",
    method: "POST",
    data,
  })
}

// 添加闲鱼参数
export function xianyuPluginAddXianyu(data) {
  return request({
    url: "/api/xianyuPlugin/add_xianyu",
    method: "POST",
    data,
  })
}

// 删除闲鱼参数
export function xianyuPluginDelXianyu(data) {
  return request({
    url: "/api/xianyuPlugin/del_xianyu",
    method: "POST",
    data,
  })
}

// 同步店铺账号
export function xianyuPluginSynchronous(data) {
  return request({
    url: "/api/xianyuPlugin/synchronous",
    method: "POST",
    data,
  })
}

// 获取闲鱼店铺列表
export function xianyuPluginListXianyuUser(data) {
  return request({
    url: "/api/xianyuPlugin/list_xianyu_user",
    method: "POST",
    data,
  })
}

// 编辑闲鱼店铺
export function xianyuPluginSaveXianyuUser(data) {
  return request({
    url: "/api/xianyuPlugin/save_xianyu_user",
    method: "POST",
    data,
  })
}

// 添加闲鱼店铺
export function xianyuPluginAddXianyuUser(data) {
  return request({
    url: "/api/xianyuPlugin/add_xianyu_user",
    method: "POST",
    data,
  })
}

// 删除闲鱼店铺
export function xianyuPluginDelXianyuUser(data) {
  return request({
    url: "/api/xianyuPlugin/del_xianyu_user",
    method: "POST",
    data,
  })
}

// 添加支付宝参数
export function alipaypluginAddAlipay(data) {
  return request({
    url: "/api/alipayplugin/add_alipay",
    method: "POST",
    data,
  })
}

// 修改支付宝参数
export function alipaypluginSaveAlipay(data) {
  return request({
    url: "/api/alipayplugin/save_alipay",
    method: "POST",
    data,
  })
}

// 删除支付宝参数
export function alipaypluginDelAlipay(data) {
  return request({
    url: "/api/alipayplugin/del_alipay",
    method: "POST",
    data,
  })
}

// 添加免押参数
export function depositpluginAddDeposit(data) {
  return request({
    url: "/api/depositplugin/add_deposit",
    method: "POST",
    data,
  })
}

// 修改免押参数
export function depositpluginSaveDeposit(data) {
  return request({
    url: "/api/depositplugin/save_deposit",
    method: "POST",
    data,
  })
}

// 删除免押参数
export function depositpluginDelDeposit(data) {
  return request({
    url: "/api/depositplugin/del_deposit",
    method: "POST",
    data,
  })
}

// 添加短信参数
export function smspluginAddSms(data) {
  return request({
    url: "/api/smsplugin/add_sms",
    method: "POST",
    data,
  })
}

// 修改短信参数
export function smspluginSaveSms(data) {
  return request({
    url: "/api/smsplugin/save_sms",
    method: "POST",
    data,
  })
}

// 删除免押参数
export function smspluginDelSms(data) {
  return request({
    url: "/api/smsplugin/del_sms",
    method: "POST",
    data,
  })
}

// 售后订单列表
export function chargeSalesServiceList(data) {
  return request({
    url: "/api/charge/sales_service_list",
    method: "POST",
    data,
  })
}

// 添加售后子单
export function chargeSalesServiceAdd(data) {
  return request({
    url: "/api/charge/sales_service_add",
    method: "POST",
    data,
  })
}

// 售后子单状态处理
export function chargeSalesServiceSave(data) {
  return request({
    url: "/api/charge/sales_service_save",
    method: "POST",
    data,
  })
}

// 外部订单列表
export function chargeExternalOrderList(data) {
  return request({
    url: "/api/charge/external_order_list",
    method: "POST",
    data,
  })
}

// 手动添加第三方订单
export function chargeExternalOrderAdd(data) {
  return request({
    url: "/api/charge/external_order_add",
    method: "POST",
    data,
  })
}

// 外部订单删除
export function chargeExternalOrderDel(data) {
  return request({
    url: "/api/charge/external_order_del",
    method: "POST",
    data,
  })
}

// 外部订单修改
export function chargeExternalOrderSave(data) {
  return request({
    url: "/api/charge/external_order_save",
    method: "POST",
    data,
  })
}

// 标记生成免押码
export function mianyabiaoji(data) {
  return request({
    url: "/api/charge/mianyabiaoji",
    method: "POST",
    data,
  })
}

// 对应免押方式的商品列表
export function chargeGetGoods(data) {
  return request({
    url: "/api/charge/get_goods",
    method: "POST",
    data,
  })
}

// 获取免押码
export function chargeQrcode(data) {
  return request({
    url: "/api/charge/qrcode",
    method: "POST",
    data,
  })
}

// 修改订单信息-仓管用
export function orderLogisticsUpdate(data) {
  return request({
    url: "/api/user/order_logistics_update",
    method: "POST",
    data,
  })
}

// 库存甘特图
export function ganttChart(data) {
  return request({
    url: "/api/index/gantt_chart",
    method: "POST",
    data,
  })
}

// 日志列表
export function userLog(data) {
  return request({
    url: "/api/user/user_log",
    method: "POST",
    data,
  })
}

// 订单日志
export function order_list_log(data) {
  return request({
    url: "/api/user/order_list_log",
    method: "POST",
    data,
  })
}

// 多仓库查询
export function inventory_statistics_list_new(data) {
  return request({
    url: "/api/user/inventory_statistics_list_new",
    method: "POST",
    data,
  })
}

// 多仓库查询-new
export function inventory_statistics_3_combo(data) {
  return request({
    url: "/api/index/inventory_statistics_3_combo",
    method: "POST",
    data,
  })
}

// 查询库存SN
export function getSnInfo(data) {
  return request({
    url: "/api/index/get_sn_info",
    method: "POST",
    data,
  })
}

// 下载导入表格模版
export function importDownload(data) {
  return request({
    url: "/api/import/download",
    method: "POST",
    data,
  })
}

// 传入导入表格
export function importImport({file}) {
  const formData = new FormData()
  formData.append("file", file)
  return request({
    url: "/api/import/import",
    method: "post",
    data: formData,
    contentType: "multipart/form-data"
  })
}

// 确认导入
export function importConfirm(data) {
  return request({
    url: "/api/import/confirm",
    method: "get",
    data,
  })
}

// 导出库存
export function importStockDaochu(data) {
  return request({
    url: "/api/import/stock_daochu",
    method: "POST",
    data,
  })
}

// 预发货设置
export function order_shipping_prefabricated(data) {
  return request({
    url: "/api/user/order_shipping_prefabricated",
    method: "POST",
    data,
  })
}

// 取消顺丰发货
export function order_sf_withdraw(data) {
  return request({
    url: "/api/user/order_sf_withdraw",
    method: "POST",
    data,
  })
}

// 顺丰运费记录
export function express_pay_list(data) {
  return request({
    url: "/api/user/express_pay_list",
    method: "POST",
    data,
  })
}

// 修改运费备注
export function express_pay_save(data) {
  return request({
    url: "/api/user/express_pay_save",
    method: "POST",
    data,
  })
}

// 闲鱼订单详情
export function get_xianyu_info(data) {
  return request({
    url: "/api/user/get_xianyu_info",
    method: "POST",
    data,
  })
}

// 库存日志列表
export function stock_log(data) {
  return request({
    url: "/api/user/stock_log",
    method: "POST",
    data,
  })
}

// 退单
export function order_refund(data) {
  return request({
    url: "/api/user/order_refund",
    method: "POST",
    data,
  })
}

// 月结到付
export function month_settlement(data) {
  return request({
    url: "/api/user/month_settlement",
    method: "POST",
    data,
  })
}

// 公告列表
export function announcement(data) {
  return request({
    url: "/api/user/announcement",
    method: "POST",
    data,
  })
}

// 是否永久不显示更新公告
export function user_update(data) {
  return request({
    url: "/api/user/user_update",
    method: "POST",
    data,
  })
}

// 标记读取公告
export function bjdq(data) {
  return request({
    url: "/api/user/bjdq",
    method: "POST",
    data,
  })
}

// 新品公告列表
export function announcement_goods(data) {
  return request({
    url: "/api/user/announcement_goods",
    method: "POST",
    data,
  })
}

// 标记读取新品公告
export function bjdq_goods(data) {
  return request({
    url: "/api/user/bjdq_goods",
    method: "POST",
    data,
  })
}

// 库存商品套餐查询
export function stock_package_statistics(data) {
  return request({
    url: "/api/user/stock_package_statistics",
    method: "POST",
    data,
  })
}

// 盘点计划列表
export function inventory_list(data) {
  return request({
    url: "/api/storehouse/inventory_list",
    method: "POST",
    data,
  })
}

// 盘点计划备注
export function inventory_remark(data) {
  return request({
    url: "/api/storehouse/inventory_remark",
    method: "POST",
    data,
  })
}

// 盘点计划删除
export function inventory_del(data) {
  return request({
    url: "/api/storehouse/inventory_del",
    method: "POST",
    data,
  })
}

// 创建盘点计划
export function inventory_add(data) {
  return request({
    url: "/api/storehouse/inventory_add",
    method: "POST",
    data,
  })
}

// 被标记机器列表
export function inventory_item_list(data) {
  return request({
    url: "/api/storehouse/inventory_item_list",
    method: "POST",
    data,
  })
}

// 结果计算
export function inventory_statistics(data) {
  return request({
    url: "/api/storehouse/inventory_statistics",
    method: "POST",
    data,
  })
}

// 生成免押码
export function charge_qrcode(data) {
  return request({
    url: "/api/charge/qrcode",
    method: "POST",
    data,
  })
}

// 按照地址查询最近仓库
export function storehouse_goods_address_list(data) {
  return request({
    url: "/api/storehouse/storehouse_goods_address_list",
    method: "POST",
    data,
  })
}

// 创建调货任务
export function replacement_add(data) {
  return request({
    url: "/api/replacement/replacement_add",
    method: "POST",
    data,
  })
}

// 商户看套餐列表
export function replacement_combo_list(data) {
  return request({
    url: "/api/replacement/replacement_combo_list",
    method: "POST",
    data,
  })
}

// 商户看额外配件列表
export function replacement_accessories_list(data) {
  return request({
    url: "/api/replacement/replacement_accessories_list",
    method: "POST",
    data,
  })
}

// 调货任务列表
export function replacement_list(data) {
  return request({
    url: "/api/replacement/replacement_list",
    method: "POST",
    data,
  })
}

// 调货任务详情
export function replacement_info(data) {
  return request({
    url: "/api/replacement/replacement_info",
    method: "POST",
    data,
  })
}

// 调货任务修改
export function replacement_save(data) {
  return request({
    url: "/api/replacement/replacement_save",
    method: "POST",
    data,
  })
}

// 调货任务取消
export function replacement_cancel(data) {
  return request({
    url: "/api/replacement/replacement_cancel",
    method: "POST",
    data,
  })
}

// 仓库发货
export function replacement_start(data) {
  return request({
    url: "/api/replacement/replacement_start",
    method: "POST",
    data,
  })
}

// 仓管收货
export function replacement_end(data) {
  return request({
    url: "/api/replacement/replacement_end",
    method: "POST",
    data,
  })
}

// 仓管核验完成
export function replacement_verification(data) {
  return request({
    url: "/api/replacement/replacement_verification",
    method: "POST",
    data,
  })
}

// 平台确认
export function replacement_confirm(data) {
  return request({
    url: "/api/replacement/replacement_confirm",
    method: "POST",
    data,
  })
}

// 长租优惠列表
export function longrent_list(data) {
  return request({
    url: "/api/longrent/longrent_list",
    method: "POST",
    data,
  })
}

// 长租优惠添加
export function longrent_add(data) {
  return request({
    url: "/api/longrent/longrent_add",
    method: "POST",
    data,
  })
}

// 长租优惠编辑
export function longrent_save(data) {
  return request({
    url: "/api/longrent/longrent_save",
    method: "POST",
    data,
  })
}

// 长租优惠删除
export function longrent_del(data) {
  return request({
    url: "/api/longrent/longrent_del",
    method: "POST",
    data,
  })
}

// 订单导出
export function order_export(data) {
  return request({
    url: "/api/import/order_export",
    method: "POST",
    data,
  })
}

// 仓库设备列表
export function storehouse_equipment_list(data) {
  return request({
    url: "/api/storehouseconfig/storehouse_equipment_list",
    method: "POST",
    data,
  })
}

// 仓库设备添加
export function storehouse_equipment_add(data) {
  return request({
    url: "/api/storehouseconfig/storehouse_equipment_add",
    method: "POST",
    data,
  })
}

// 仓库设备修改
export function storehouse_equipment_save(data) {
  return request({
    url: "/api/storehouseconfig/storehouse_equipment_save",
    method: "POST",
    data,
  })
}

// 仓库设备删除
export function storehouse_equipment_del(data) {
  return request({
    url: "/api/storehouseconfig/storehouse_equipment_del",
    method: "POST",
    data,
  })
}

// 仓库发货时间配置列表
export function storehouse_config_list(data) {
  return request({
    url: "/api/storehouseconfig/storehouse_config_list",
    method: "POST",
    data,
  })
}

// 仓库发货时间配置添加
export function storehouse_config_add(data) {
  return request({
    url: "/api/storehouseconfig/storehouse_config_add",
    method: "POST",
    data,
  })
}

// 仓库发货时间配置修改
export function storehouse_config_save(data) {
  return request({
    url: "/api/storehouseconfig/storehouse_config_save",
    method: "POST",
    data,
  })
}

// 仓库发货时间配置删除
export function storehouse_config_del(data) {
  return request({
    url: "/api/storehouseconfig/storehouse_config_del",
    method: "POST",
    data,
  })
}

// 新版统计
export function statistics_new_order(data) {
  return request({
    url: "/api/statistics/new_order",
    method: "POST",
    data,
  })
}

// 新订单统计
export function statistics_new_data1(data) {
  return request({
    url: "/api/statistics/new_data1",
    method: "POST",
    data,
  })
}

// 新商品统计
export function statistics_new_data2(data) {
  return request({
    url: "/api/statistics/new_data2",
    method: "POST",
    data,
  })
}

// 新商品统计
export function statistics_V4_a4(data) {
  return request({
    url: "/api/Statistics/statistics_V4_a4",
    method: "POST",
    data,
  })
}

// 商品城市出租率
export function urban_occupancy_rate(data) {
  return request({
    url: "/api/statistics/urban_occupancy_rate",
    method: "POST",
    data,
  })
}

// 修改支付方式
export function update_renew_lease(data) {
  return request({
    url: "/api/user/update_renew_lease",
    method: "POST",
    data,
  })
}

// 手动填写开票信息 客服用的
export function ticket_save(data) {
  return request({
    url: "/api/ticket/ticket_save",
    method: "POST",
    data,
  })
}

// 开票处理
export function ticket_deal(data) {
  return request({
    url: "/api/ticket/ticket_deal",
    method: "POST",
    data,
  })
}

// 订单导入
export function import_orderImport({file}) {
  const formData = new FormData()
  formData.append("file", file)
  return request({
    url: "/api/import/order_import",
    method: "post",
    data: formData,
    contentType: "multipart/form-data"
  })
}

// 订单导出
export function import_orderDaochu(data) {
  return request({
    url: "/api/import/order_daochu",
    method: "POST",
    data,
  })
}

// 手动同步
export function manual_synchronization(data) {
  return request({
    url: "/api/charge/manual_synchronization",
    method: "POST",
    data,
  })
}

// 员工列表导出
export function import_userDaochu(data) {
  return request({
    url: "/api/import/user_daochu",
    method: "POST",
    data,
  })
}

// 退款申请添加
export function refund_add(data) {
  return request({
    url: "/api/refund/refund_add",
    method: "POST",
    data,
  })
}

// 退租申请表
export function refund_list(data) {
  return request({
    url: "/api/refund/refund_list",
    method: "POST",
    data,
  })
}

// 退款申请处理
export function refund_save(data) {
  return request({
    url: "/api/refund/refund_save",
    method: "POST",
    data,
  })
}

// 申请免押扣款
export function charge_deposit_deduction(data) {
  return request({
    url: "/api/charge/deposit_deduction",
    method: "POST",
    data,
  })
}

// 结算撤回
export function order_settlement_rollback(data) {
  return request({
    url: "/api/user/order_settlement_rollback",
    method: "POST",
    data,
  })
}

// 结算撤回_V2
export function order_settlement_rollback_V2(data) {
  return request({
    url: "/api/settlement/order_settlement_rollback_V2",
    method: "POST",
    data,
  })
}

// 结算取消_V2
export function order_settlement_cancel_V2(data) {
  return request({
    url: "/api/settlement/order_settlement_cancel_V2",
    method: "POST",
    data,
  })
}

// 售后打款添加
export function refundsales_add(data) {
  return request({
    url: "/api/refundsales/refundsales_add",
    method: "POST",
    data,
  })
}

// 售后打款列表
export function refundsales_list(data) {
  return request({
    url: "/api/refundsales/refundsales_list",
    method: "POST",
    data,
  })
}

// 售后打款处理
export function refundsales_save(data) {
  return request({
    url: "/api/refundsales/refundsales_save",
    method: "POST",
    data,
  })
}

// 公司列表
export function user_company(data) {
  return request({
    url: "/api/user/company",
    method: "POST",
    data,
  })
}

// ----------------- 长租
// 获取商品列表
export function long_goods(data) {
  return request({
    url: "/api/longorder/long_goods",
    method: "GET",
    data,
  })
}

// 长租订单列表
export function longorder_order(data) {
  return request({
    url: "/api/longorder/longorder_order",
    method: "POST",
    data,
  })
}

// 长租订单修改
export function longorder_save(data) {
  return request({
    url: "/api/longorder/longorder_save",
    method: "POST",
    data,
  })
}

// 长租订单发货
export function longorder_shipping(data) {
  return request({
    url: "/api/longorder/longorder_shipping",
    method: "POST",
    data,
  })
}

// 长租订单收货
export function longorder_receipt(data) {
  return request({
    url: "/api/longorder/longorder_receipt",
    method: "POST",
    data,
  })
}

// 长租理赔完成
export function longorder_sales(data) {
  return request({
    url: "/api/longorder/longorder_sales",
    method: "POST",
    data,
  })
}

// 查看手机号
export function query_mobile(data) {
  return request({
    url: "/api/user/query_mobile",
    method: "POST",
    data,
  })
}

// 获取商家
export function long_merchant(data) {
  return request({
    url: "/api/longorder/long_merchant",
    method: "POST",
    data,
  })
}

// 生成二维码
export function long_ewm(data) {
  return request({
    url: "/api/longorder/long_ewm",
    method: "POST",
    data,
  })
}

// 订单查询风控
export function charge_risk(data) {
  return request({
    url: "/api/charge/risk",
    method: "POST",
    data,
  })
}

// 加价列表
export function markup_list(data) {
  return request({
    url: "/api/markup/markup_list",
    method: "POST",
    data,
  })
}

// 加价添加
export function markup_add(data) {
  return request({
    url: "/api/markup/markup_add",
    method: "POST",
    data,
  })
}

// 加价编辑
export function markup_save(data) {
  return request({
    url: "/api/markup/markup_save",
    method: "POST",
    data,
  })
}

// 加价删除
export function markup_del(data) {
  return request({
    url: "/api/markup/markup_del",
    method: "POST",
    data,
  })
}

// 预发货设置
export function longorder_shipping_prefabricated(data) {
  return request({
    url: "/api/longorder/longorder_shipping_prefabricated",
    method: "POST",
    data,
  })
}

// 长租订单获取分期账单信息
export function longorder_item(data) {
  return request({
    url: "/api/longorder/longorder_item",
    method: "POST",
    data,
  })
}

// 长租标记单期账单支付
export function longorder_pay(data) {
  return request({
    url: "/api/longorder/longorder_pay",
    method: "POST",
    data,
  })
}

// 长租订单支付方式修改
export function longorder_pay_update(data) {
  return request({
    url: "/api/longorder/longorder_pay_update",
    method: "POST",
    data,
  })
}

// 手动添加第三方订单
export function longorder_zhuan(data) {
  return request({
    url: "/api/longorder/longorder_zhuan",
    method: "POST",
    data,
  })
}

// 取消顺丰发货-长租
export function longorder_order_sf_withdraw(data) {
  return request({
    url: "/api/longorder/order_sf_withdraw",
    method: "POST",
    data,
  })
}

// 修改订单信息-长租-仓管用
export function longorder_orderLogisticsUpdate(data) {
  return request({
    url: "/api/longorder/order_logistics_update",
    method: "POST",
    data,
  })
}

// 订单备注添加-长租
export function longorder_orderRemarkAdd(data) {
  return request({
    url: "/api/longorder/order_remark_add",
    method: "POST",
    data,
  })
}

// 订单备注列表-长租
export function longorder_orderRemarkList(data) {
  return request({
    url: "/api/longorder/order_remark_list",
    method: "POST",
    data,
  })
}

// 查询订单风控
export function user_fk(data) {
  return request({
    url: "/api/user/fk",
    method: "POST",
    data,
  })
}

// 长租订单日志
export function longorder_order_log_list(data) {
  return request({
    url: "/api/longorder/order_log_list",
    method: "POST",
    data,
  })
}

// 异常后重新同步
export function charge_pull(data) {
  return request({
    url: "/api/charge/pull",
    method: "POST",
    data,
  })
}

// 修改长租备注
export function longorder_beizhu(data) {
  return request({
    url: "/api/longorder/longorder_beizhu",
    method: "POST",
    data,
  })
}

// 订单共租信息
export function order_shared_list(data) {
  return request({
    url: "/api/user/order_shared_list",
    method: "POST",
    data,
  })
}

// 长租订单修改
export function order_update_goods(data) {
  return request({
    url: "/api/longorder/order_update_goods",
    method: "POST",
    data,
  })
}

// 长租取消订单
export function longorder_cancel(data) {
  return request({
    url: "/api/longorder/longorder_cancel",
    method: "POST",
    data,
  })
}

// 长租续租
export function longorder_relet(data) {
  return request({
    url: "/api/longorder/longorder_relet",
    method: "POST",
    data,
  })
}

// 风控配置详情
export function supplier_risk_info(data) {
  return request({
    url: "/api/risk/supplier_risk_info",
    method: "GET",
    data,
  })
}

// 风控配置详情保存
export function supplier_risk_save(data) {
  return request({
    url: "/api/risk/supplier_risk_save",
    method: "POST",
    data,
  })
}

// 风控审核列表
export function supplier_risk_order(data) {
  return request({
    url: "/api/risk/supplier_risk_order",
    method: "POST",
    data,
  })
}

// 风控审核操作
export function supplier_risk_handle(data) {
  return request({
    url: "/api/risk/supplier_risk_handle",
    method: "POST",
    data,
  })
}

// 手动查询风控
export function supplier_risk_query(data) {
  return request({
    url: "/api/risk/supplier_risk_query",
    method: "POST",
    data,
  })
}

// 仓库日历
export function statistics_V4_a1(data) {
  return request({
    url: "/api/statistics/statistics_V4_a1",
    method: "POST",
    data,
  })
}

// 仓库订单纬度
export function statistics_V4_a2(data) {
  return request({
    url: "/api/statistics/statistics_V4_a2",
    method: "POST",
    data,
  })
}

// 仓库订单纬度
export function statistics_V4_a3(data) {
  return request({
    url: "/api/statistics/statistics_V4_a3",
    method: "POST",
    data,
  })
}

// 仓库列表
export function statistics_V4_b1(data) {
  return request({
    url: "/api/statistics/statistics_V4_b1",
    method: "POST",
    data,
  })
}

// 仓库详情
export function statistics_V4_b2(data) {
  return request({
    url: "/api/statistics/statistics_V4_b2",
    method: "POST",
    data,
  })
}

// 仓库基础数据更新
export function statistics_V4_b3(data) {
  return request({
    url: "/api/statistics/statistics_V4_b3",
    method: "POST",
    data,
  })
}

// 仓库套餐数量修改
export function statistics_V4_b4(data) {
  return request({
    url: "/api/statistics/statistics_V4_b4",
    method: "POST",
    data,
  })
}

// 仓库数据修改
export function statistics_V4_b5(data) {
  return request({
    url: "/api/statistics/statistics_V4_b5",
    method: "POST",
    data,
  })
}

// 仓库商品列表
export function statistics_V4_b6(data) {
  return request({
    url: "/api/statistics/statistics_V4_b6",
    method: "POST",
    data,
  })
}

// 长租订单修改备注
export function remark_save(data) {
  return request({
    url: "/api/charge/remark_save",
    method: "POST",
    data,
  })
}

// 长租解除免押
export function longorder_order_unfreeze(data) {
  return request({
    url: "/api/longorder/order_unfreeze",
    method: "POST",
    data,
  })
}

// 长租订单确认归还
export function longorder_order_return(data) {
  return request({
    url: "/api/longorder/order_return",
    method: "POST",
    data,
  })
}

// 长租状态回滚
export function longorder_order_withdraw(data) {
  return request({
    url: "/api/longorder/order_withdraw",
    method: "POST",
    data,
  })
}

// 短租设置补充押金
export function order_set_pledge(data) {
  return request({
    url: "/api/user/order_set_pledge",
    method: "POST",
    data,
  })
}

// 长租设置补充押金
export function longorder_set_pledge(data) {
  return request({
    url: "/api/longorder/longorder_set_pledge",
    method: "POST",
    data,
  })
}

// 长租订单单期退款
export function longorder_pay_refund(data) {
  return request({
    url: "/api/longorder/longorder_pay_refund",
    method: "POST",
    data,
  })
}

// 转仓手动
export function manual_warehouse_transfer(data) {
  return request({
    url: "/api/storehouse/manual_warehouse_transfer",
    method: "POST",
    data,
  })
}

// 转仓自动
export function auto_warehouse_transfer(data) {
  return request({
    url: "/api/storehouse/auto_warehouse_transfer",
    method: "POST",
    data,
  })
}

// 长租月结到付
export function longorder_month_settlement(data) {
  return request({
    url: "/api/longorder/month_settlement",
    method: "POST",
    data,
  })
}

// 黑名单列表
export function member_list(data) {
  return request({
    url: "/api/member/member_list",
    method: "POST",
    data,
  })
}

// 黑名单添加
export function member_add(data) {
  return request({
    url: "/api/member/member_add",
    method: "POST",
    data,
  })
}

// 黑名单修改
export function member_save(data) {
  return request({
    url: "/api/member/member_save",
    method: "POST",
    data,
  })
}

// 黑名单删除
export function member_del(data) {
  return request({
    url: "/api/member/member_del",
    method: "POST",
    data,
  })
}

// 经营分类列表
export function operation_list(data) {
  return request({
    url: "/api/operation/operation_list",
    method: "POST",
    data,
  })
}

// 经营分类添加
export function operation_add(data) {
  return request({
    url: "/api/operation/operation_add",
    method: "POST",
    data,
  })
}

// 经营分类修改
export function operation_save(data) {
  return request({
    url: "/api/operation/operation_save",
    method: "POST",
    data,
  })
}

// 经营分类删除
export function operation_del(data) {
  return request({
    url: "/api/operation/operation_del",
    method: "POST",
    data,
  })
}

// 补充押金退款-短租
export function order_set_pledge_refund(data) {
  return request({
    url: "/api/user/order_set_pledge_refund",
    method: "POST",
    data,
  })
}

// 补充押金退款-长租
export function longorder_set_pledge_refund(data) {
  return request({
    url: "/api/longorder/longorder_set_pledge_refund",
    method: "POST",
    data,
  })
}

// 查询SN待收货订单
export function order_stock_info(data) {
  return request({
    url: "/api/user/order_stock_info",
    method: "POST",
    data,
  })
}

// 查询回执照片-短
export function get_order_sf_image(data) {
  return request({
    url: "/api/user/get_order_sf_image",
    method: "POST",
    data,
  })
}

// 查询回执照片-长
export function get_long_order_sf_image(data) {
  return request({
    url: "/api/user/get_long_order_sf_image",
    method: "POST",
    data,
  })
}

// 货品方存储物品统计
export function supplier_stock(data) {
  return request({
    url: "/api/supplier/supplier_stock",
    method: "POST",
    data,
  })
}

// 查询免押
export function third_free_list(data) {
  return request({
    url: "/api/charge/third_free_list",
    method: "POST",
    data,
  })
}

// 免押流程-完结订单
export function lzp_order_unfreeze(data) {
  return request({
    url: "/api/charge/lzp_order_unfreeze",
    method: "POST",
    data,
  })
}

// 免押流程-跳过人脸
export function lzp_order_face(data) {
  return request({
    url: "/api/charge/lzp_order_face",
    method: "POST",
    data,
  })
}

// 理赔修正
export function claim_settlement_correction(data) {
  return request({
    url: "/api/longorder/claim_settlement_correction",
    method: "POST",
    data,
  })
}

// 理赔详情
export function long_order_settlement_list(data) {
  return request({
    url: "/api/longorder/long_order_settlement_list",
    method: "POST",
    data,
  })
}

// 长租结算撤回
export function long_order_settlement_rollback_V2(data) {
  return request({
    url: "/api/settlement/long_order_settlement_rollback_V2",
    method: "POST",
    data,
  })
}

// 耗材列表
export function consumables_list(data) {
  return request({
    url: "/api/consumables/consumables_list",
    method: "POST",
    data,
  })
}

// 耗材添加
export function consumables_add(data) {
  return request({
    url: "/api/consumables/consumables_add",
    method: "POST",
    data,
  })
}

// 耗材编辑
export function consumables_save(data) {
  return request({
    url: "/api/consumables/consumables_save",
    method: "POST",
    data,
  })
}

// 耗材删除
export function consumables_del(data) {
  return request({
    url: "/api/consumables/consumables_del",
    method: "POST",
    data,
  })
}

// 获取乐租婆商品库
export function get_lzp_goods(data) {
  return request({
    url: "/api/external/get_lzp_goods",
    method: "POST",
    data,
  })
}

// 获取乐租婆商家
export function get_lzp_merchant(data) {
  return request({
    url: "/api/external/get_lzp_merchant",
    method: "POST",
    data,
  })
}

// 分配商家至乐租婆
export function allot_mer(data) {
  return request({
    url: "/api/external/allot_mer",
    method: "POST",
    data,
  })
}

// 标记订单是否可结算
export function order_settlement_is(data) {
  return request({
    url: "/api/user/order_settlement_is",
    method: "POST",
    data,
  })
}

// 站内信列表
export function message_message_list(data) {
  return request({
    url: "/api/message/message_list",
    method: "POST",
    data,
  })
}

// 站内信标记已读
export function message_message_mark(data) {
  return request({
    url: "/api/message/message_mark",
    method: "POST",
    data,
  })
}

// 合作商家列表
export function cooperation_cooperation_list(data) {
  return request({
    url: "/api/cooperation/cooperation_list",
    method: "POST",
    data,
  })
}

// 合作商家添加
export function cooperation_cooperation_add(data) {
  return request({
    url: "/api/cooperation/cooperation_add",
    method: "POST",
    data,
  })
}

// 合作商家编辑
export function cooperation_cooperation_save(data) {
  return request({
    url: "/api/cooperation/cooperation_save",
    method: "POST",
    data,
  })
}

// 合作商家删除
export function cooperation_cooperation_del(data) {
  return request({
    url: "/api/cooperation/cooperation_del",
    method: "POST",
    data,
  })
}

// 获取合作商家商品
export function cooperation_get_goods(data) {
  return request({
    url: "/api/cooperation/get_goods",
    method: "POST",
    data,
  })
}